import React, { useContext, useEffect, useReducer, useState } from "react";
import { useHistory } from "react-router";
import CartContext from "../../../cartcontext/CartContext";
import LoaderContext from "../../../loadercontext/LoaderContext";
import TimeContext from "../../../timecontext/TimeContext";
import ToastContext from "../../../toastcontext/ToastContext";

import OrderService from "../services/OrderService";
import PinPointMap from "./map/PinPointMap";

const initialState = {
  name: "",
  phone: "",
  confirm_phone: "",
  email: "",
  confirm_email: "",
  address: "",
  deliveryarea: "Boudha",
  payment: "Cash",
  summary: "",
  amount: "",
  jsonobject: "",
  geo: "27.720971,85.361866",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "name":
      return { ...state, name: action.payload };
    case "phone":
      return { ...state, phone: action.payload };
    case "confirm_phone":
      return { ...state, confirm_phone: action.payload };
    case "email":
      return { ...state, email: action.payload };
    case "confirm_email":
      return { ...state, confirm_email: action.payload };
    case "address":
      return { ...state, address: action.payload };
    case "deliveryarea":
      return { ...state, deliveryarea: action.payload };
    case "geo":
      return { ...state, geo: action.payload };
    case "payment":
      return { ...state, payment: action.payload };
    case "summary":
      return { ...state, summary: action.payload };
    case "amount":
      return { ...state, amount: action.payload };
    case "jsonobject":
      return { ...state, jsonobject: action.payload };

    default:
      throw new Error();
  }
};

const deliveryLocationData = [
  { location: "Boudha", geo: { lat: 27.720971, long: 85.361866 } },
  { location: "Aarubari", geo: { lat: 27.733167, long: 85.377696 } },
  { location: "Tinchuli", geo: { lat: 27.726969, long: 85.368562 } },
  { location: "Jorpati", geo: { lat: 27.721813, long: 85.373104 } },
  { location: "Besigaon", geo: { lat: 27.726814, long: 85.377258 } },
];

function Checkout() {
  const [formState, dispatch] = useReducer(reducer, initialState);

  const [isConfirm_Phone, setIsConfirm_Phone] = useState(null);
  const [isConfirm_Email, setIsConfirm_Email] = useState(null);

  const { cartState, dispatchCart, getSum, IsOpen, getQty } = useContext(
    CartContext
  );

  const { setBusy } = useContext(LoaderContext);

  const { PostOrder } = OrderService();

  const history = useHistory();

  const { isStoreClosed } = useContext(TimeContext);

  const [deliveryLocation, setDeliveryLocation] = useState(
    deliveryLocationData[0].geo
  );

  useEffect(() => {
    let summary = "";
    cartState.forEach((d) => {
      summary =
        `${d.qty} X ${d.order.food} (Rs ${d.order.price}) = Rs ${
          d.qty * d.order.price
        } \n` + summary;
    });
    summary = summary + "\n" + "Total: Rs " + getSum();
    dispatch({ type: "summary", payload: summary });
    dispatch({ type: "amount", payload: getSum() });
    dispatch({ type: "jsonobject", payload: JSON.stringify(cartState) });
  }, [cartState]);

  const CheckFormValid = () => {
    return (
      formState.name === "" ||
      formState.phone === "" ||
      formState.confirm_phone === "" ||
      formState.email === "" ||
      formState.confirm_email === "" ||
      formState.address === "" ||
      formState.deliveryarea === "" ||
      formState.payment === "" ||
      formState.summary === "" ||
      cartState.length === 0 ||
      formState.phone !== formState.confirm_phone ||
      formState.email !== formState.confirm_email ||
      !validateEmail(formState.email) ||
      !validateEmail(formState.confirm_email) ||
      getSum() < 120
    );
  };

  const FormAlert = (message) => (
    <div className="alert alert-danger" role="alert">
      {message}
    </div>
  );

  const validateEmail = (email) => {
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexp.test(email);
  };

  const { setToast } = useContext(ToastContext);

  return (
    <div className="row no-gutters">
      <div className="col-12">
        {cartState.length === 0 ? FormAlert("Cart is empty") : ""}
        <form
          className="container"
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            const res = await PostOrder(formState);
            try {
              const { message } = res.data;
              setToast({ show: true, title: "INFO", description: message });
              localStorage.setItem("cart", []);
              history.push("/");
            } catch (error) {
              setToast({ show: true, title: "ERROR", description: error });
            }
            setBusy(false);
          }}
        >
          <h5 className="text-danger font-weight-bold">Checkout</h5>
          <div className="form-group pt-3">
            <label htmlFor="Name">Name *</label>
            <input
              onChange={(e) => {
                const name = e.target.value;
                dispatch({ type: "name", payload: name });
              }}
              type="text"
              className="form-control form-control-sm"
              id="Name"
              placeholder="Enter Name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="Phone">Phone *</label>
            {!isConfirm_Phone && isConfirm_Phone != null
              ? FormAlert("Phone not matched")
              : ""}
            <div className="form-row">
              <div className="col">
                <input
                  onChange={(e) => {
                    const phone = e.target.value;
                    dispatch({ type: "phone", payload: phone });
                    setIsConfirm_Phone(
                      formState.confirm_phone === phone ? true : false
                    );
                  }}
                  type="tel"
                  className="form-control form-control-sm"
                  id="phone"
                  placeholder="Enter Phone"
                  required
                />
              </div>
              <div className="col">
                <input
                  value={formState.confirm_phone}
                  onChange={(e) => {
                    const confirm_phone = e.target.value;
                    dispatch({ type: "confirm_phone", payload: confirm_phone });
                    setIsConfirm_Phone(
                      formState.phone === confirm_phone ? true : false
                    );
                  }}
                  type="tel"
                  className="form-control form-control-sm"
                  id="phone"
                  placeholder="Confirm Phone"
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="Phone">Email *</label>
            {!isConfirm_Email && isConfirm_Email != null
              ? FormAlert("Email not matched")
              : ""}

            <div className="form-row">
              <div className="col-12">
                <input
                  onChange={(e) => {
                    const email = e.target.value;
                    dispatch({ type: "email", payload: email });
                    setIsConfirm_Email(
                      formState.confirm_email === email ? true : false
                    );
                  }}
                  type="email"
                  className="form-control form-control-sm"
                  id="phone"
                  placeholder="Enter Email"
                  required
                />
              </div>
            </div>
            <label htmlFor="Phone">Confirm Email *</label>
            <div className="form-row">
              <div className="col-12">
                <input
                  onChange={(e) => {
                    const confirm_email = e.target.value;
                    dispatch({ type: "confirm_email", payload: confirm_email });
                    setIsConfirm_Email(
                      formState.email === confirm_email ? true : false
                    );
                  }}
                  type="email"
                  className="form-control form-control-sm"
                  id="phone"
                  placeholder="Confirm Email"
                  required
                />
              </div>{" "}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="address">Address *</label>
            <input
              onChange={(e) => {
                const address = e.target.value;
                dispatch({ type: "address", payload: address });
              }}
              type="text"
              className="form-control form-control-sm"
              id="phone"
              placeholder="Enter Address"
            />
          </div>
          <div className="form-group">
            <label htmlFor="deliveryarea">Delivery Area*</label>
            <select
              className="form-control form-control-sm"
              value={formState.deliveryarea}
              onChange={(e) => {
                const deliveryarea = e.target.value;
                dispatch({ type: "deliveryarea", payload: deliveryarea });

                //set delivery address for map
                deliveryLocationData.forEach((element) => {
                  if (deliveryarea === element.location) {
                    setDeliveryLocation(element.geo);
                  }
                });
              }}
            >
              <option value="Boudha">Boudha</option>
              <option value="Aarubari">Aarubari</option>
              <option value="Tinchuli">Tinchuli</option>
              <option value="Jorpati">Jorpati</option>
              <option value="Besigaon">Besigaon</option>
            </select>
          </div>
          <PinPointMap
            deliveryLocation={deliveryLocation}
            dispatch={dispatch}
          />
          <div className="form-group">
            <label htmlFor="address">Payment Type *</label>
            <div className="input-group-prepend">
              <div className="input-group-text form-control-sm">
                <input
                  type="radio"
                  defaultChecked
                  aria-label="Radio button for following text input"
                />
                Cash
              </div>
            </div>

            <div className="input-group-prepend my-1">
              <div className="input-group-text form-control-sm">
                <input
                  disabled
                  type="radio"
                  aria-label="Radio button for following text input"
                />
                Online Payment (Coming Soon)
              </div>
            </div>
          </div>
          <div className="form-group">
            {getSum() < 120 ? (
              <p className="text-muted-sm text-danger font-weight-bold">
                Minimum order is Rs 120.00
              </p>
            ) : (
              ""
            )}
            <label htmlFor="address">Summary Type *</label>
            <div>
              {cartState.map((d, i) => (
                <div style={{ fontSize: "14px" }} key={d.guid}>
                  <p className="m-0 d-flex justify-content-between">
                    <span>
                      {d.qty} X {d.order.food}
                    </span>
                    <span style={{ width: "70px" }}>
                      Rs {d.qty * d.order.price}
                    </span>
                  </p>
                  <span
                    className="text-danger cursor-pointer"
                    onClick={() => {
                      cartState.splice(i, 1);
                      dispatchCart({ type: "REMOVE", payload: cartState });
                    }}
                  >
                    remove
                  </span>
                  <hr></hr>
                </div>
              ))}
              <p>Total Rs: {getSum()}</p>
              <p>
                Delivery Fee :
                <span style={{ textDecoration: "line-through" }}>Rs 150</span>{" "}
                Free
              </p>
              <p className="font-weight-bold">Amount Due : Rs {getSum()}</p>

              {!IsOpen() ? (
                <p className="text-muted m-0">
                  Store is closed now. Please order between 10:00 am - 7:00 pm.
                  Thank you
                </p>
              ) : (
                ""
              )}
              {getQty() > 20 ? (
                <p className="text-muted m-0">
                  Max Order 20 Qty. Please call +977-980-8011299 for catering
                  service. Thank you
                </p>
              ) : (
                ""
              )}
              {formState.email != ""
                ? !validateEmail(formState.email) ||
                  !validateEmail(formState.confirm_email)
                  ? FormAlert("Email not valid")
                  : ""
                : ""}

              {!isStoreClosed() ? (
                <p className="text-muted-sm text-danger font-weight-bold">
                  Store is closed. Please order between 10:00 am - 7:30 pm
                  GMT+5:45 time
                </p>
              ) : (
                ""
              )}

              <button
                className="btn btn-danger btn-sm  btn-block my-3"
                disabled={
                  CheckFormValid() ||
                  !IsOpen() ||
                  getQty() > 20 ||
                  !isStoreClosed()
                }
              >
                Place Order Rs. {getSum()}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Checkout;
